var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "#6D7781",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1705 2.25999H1.82954C1.31561 2.25999 0.96 2.6527 0.96 3.06325V13.9367C0.96 14.3473 1.31561 14.74 1.82954 14.74H14.1705C14.6844 14.74 15.04 14.3473 15.04 13.9367V3.06325C15.04 2.6527 14.6844 2.25999 14.1705 2.25999ZM1.82954 1.29999H14.1705C15.1809 1.29999 16 2.08943 16 3.06325V13.9367C16 14.9105 15.1809 15.7 14.1705 15.7H1.82954C0.819113 15.7 0 14.9105 0 13.9367V3.06325C0 2.08943 0.819113 1.29999 1.82954 1.29999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.944 4.49999H1.05601C0.680007 4.49999 0.432007 4.29199 0.432007 4.00399C0.432007 3.71599 0.680007 3.51599 1.05601 3.51599H14.944C15.32 3.51599 15.568 3.70799 15.568 4.00399C15.568 4.29999 15.32 4.49999 14.944 4.49999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7394 6.5606C6.92685 6.74805 6.92685 7.05197 6.7394 7.23942L4.67881 9.30001L6.7394 11.3606C6.92685 11.5481 6.92685 11.852 6.7394 12.0394C6.55195 12.2269 6.24803 12.2269 6.06058 12.0394L3.66058 9.63942C3.47313 9.45197 3.47313 9.14805 3.66058 8.9606L6.06058 6.5606C6.24803 6.37315 6.55195 6.37315 6.7394 6.5606Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2606 6.5606C9.07315 6.74805 9.07315 7.05197 9.2606 7.23942L11.3212 9.30001L9.2606 11.3606C9.07315 11.5481 9.07315 11.852 9.2606 12.0394C9.44805 12.2269 9.75197 12.2269 9.93942 12.0394L12.3394 9.63942C12.5269 9.45197 12.5269 9.14805 12.3394 8.9606L9.93942 6.5606C9.75197 6.37315 9.44805 6.37315 9.2606 6.5606Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.82ab2419.svg";
export { ForwardRef as ReactComponent };